import { Typography } from '@mui/material'

import { useTranslations } from '@/hooks/useTranslations'

import type React from 'react'
import type { TypographyProps } from '@mui/material'
import type { LocaleText as LocaleTextProps } from '@/gen/sanity/schema'

export const LocaleText: React.FC<
  LocaleTextProps & {
    typographyProps?: Partial<TypographyProps>
    className?: string
  }
> = (props) => {
  const { language } = useTranslations()

  return (
    <Typography className={props.className} {...props.typographyProps}>
      {!!props && props[language]}
    </Typography>
  )
}
